import { ReportExportType } from '@/configuration/report/report-export-types'
import { toTypedSchema } from '@vee-validate/zod'
import * as zod from 'zod'

export const exportValidationSchema = (exportType: ReportExportType) =>
    toTypedSchema(zod.object(validationSchema[exportType]))

// Validation for historical analyses (component level) - requires technical location/component ID
const historicalAnalysisValidation = {
    componentTypes: zod.number({ required_error: 'formInputs.validation.requiredSelect' }).min(1, 'formInputs.validation.requiredSelect'),
    exportType: zod.number(),
    groupSid: zod.number({ required_error: 'formInputs.validation.requiredSelect' }).min(1, 'formInputs.validation.requiredSelect'),
    plantSid: zod.number({ required_error: 'formInputs.validation.requiredSelect' }).min(1, 'formInputs.validation.requiredSelect'),
    componentSids: zod.string({ required_error: 'formInputs.validation.requiredSelect' }).min(1, 'formInputs.validation.requiredSelect'),
    startDate: zod.string().min(1, 'formInputs.validation.requiredDate'),
    endDate: zod.string().min(1, 'formInputs.validation.requiredDate'),
}

// Validation for summary status reports - component ID and dates disabled
const summaryStatusValidation = {
    componentTypes: zod.number({ required_error: 'formInputs.validation.requiredSelect' }).min(1, 'formInputs.validation.requiredSelect'),
    exportType: zod.number(),
    groupSid: zod.number({ required_error: 'formInputs.validation.requiredSelect' }).refine((value) => value > 0 || value === -1, 'formInputs.validation.requiredSelect'),
    plantSid: zod.number().array().optional(),
    componentSids: zod.string().optional(),
    startDate: zod.string().optional(),
    endDate: zod.string().optional(),
}

const validationSchema = {
    // Historical Analysis (component level) - used for both Transformer and Generator
    [ReportExportType.HistoricalAnalysis]: historicalAnalysisValidation,
    
    // Transformer Oil Analysis Status Report
    [ReportExportType.TransformerOilAnalysisStatus]: summaryStatusValidation,
    
    // Summary Condition Status - used for both Transformer and Generator
    [ReportExportType.SummaryConditionStatus]: summaryStatusValidation,
}
